<template>
  <div ref="stripe-container" class="stripe-container">
    <div ref="card" class="stripe-card"></div>
    <div class="red--text mt-1 text-xs-center" v-html="cardError"></div>
  </div>
</template>

<script>
let stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
let elements = stripe.elements();

export default {
  name: 'Stripe',
  props: ['billingDetails'],
  data () {
    return {
      card: null,
      cardError: "&nbsp;",
      cardComplete: false
    }
  },
  mounted: function() {
    this.card = elements.create('card');
    this.card.mount(this.$refs.card);
    let ref = this;
    this.card.addEventListener('change', function(event) {
      ref.cardError = (event.error ? event.error.message : "&nbsp;");

      ref.$emit( 'on-change', event);
    });
  },
  beforeDestroy: function() {
    this.card.destroy();
  },
  computed: {
    
  },
  methods: {
    getToken: function() {
      let ref = this;

      stripe.createToken(this.card).then(function(result) {
        if (result.error) {
          ref.$emit('on-error', result.error.message);
        } else {
          ref.$emit('on-token', result.token);
        }
      });
    },
    confirmIntent: function(secret, pm = null) {
      let ref = this;

      if(pm) {
        stripe.handleCardPayment(
          secret,
          {
            payment_method: pm,
          }
        ).then(function(result) {
          if (result.error) {
            ref.$emit('on-intent-error',result);
            // Display error.message in your UI.
          } else {
            //console.log(result);
            ref.$emit('on-intent-complete',result);
            // The payment has succeeded. Display a success message.
            // Then, send the payment method from the SetupIntent to your
            // server in order to attach the payment method to a customer.
          }
        });
      } else {
        stripe.handleCardPayment(
          secret, this.card, {
            payment_method_data: {
              billing_details: {
                name: ref.billingDetails.name,
                address: {
                  city: ref.billingDetails.city,
                  country: ref.billingDetails.country,
                  line1: ref.billingDetails.street,
                  postal_code: ref.billingDetails.postal,
                  state: ref.billingDetails.state
                }
              }
            },
            save_payment_method: true
          }
        ).then(function(result) {
          if (result.error) {
            ref.$emit('on-intent-error',result);
            // Display error.message in your UI.
          } else {
            //console.log(result);
            ref.$emit('on-intent-complete',result);
            // The payment has succeeded. Display a success message.
            // Then, send the payment method from the SetupIntent to your
            // server in order to attach the payment method to a customer.
          }
        });
      }

    },
    setupIntent: function(secret) {
      let ref = this;

      stripe.handleCardSetup(
        secret, this.card, {
          payment_method_data: {
            billing_details: {
              name: ref.billingDetails.name,
              address: {
                city: ref.billingDetails.city,
                country: ref.billingDetails.country,
                line1: ref.billingDetails.street,
                postal_code: ref.billingDetails.postal,
                state: ref.billingDetails.state
              }
            }
          },
        }
      ).then(function(result) {
        if (result.error) {
          ref.$emit('on-setup-intent-error',result);
        } else {
          ref.$emit('on-setup-intent-complete',result);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .stripe-card {
    padding: 15px 10px;
    border: 1px solid rgba(0,0,0,.3);
    &.StripeElement--complete {
      border-color: green;
    }
  }
</style>